import {Component, OnInit, Input} from '@angular/core';
import {QuoteService} from 'src/app/quote/quote.service';
import {environment} from 'src/environments/environment';
import {LocalStorageService} from 'ngx-webstorage';

@Component({
  selector: 'app-breakdown-financials',
  templateUrl: './breakdown-financials.component.html',
  styleUrls: ['./breakdown-financials.component.css']
})
export class BreakdownFinancialsComponent implements OnInit {
  premium: any = '{"referred": null,"ipt": 0,"gross": 0,"breakdown_ipt": 0,"breakdown_gross": 0,"total_amount": 0,"gross_premium":0,"vehicle_premiums": {},"breakdown_premiums": {},"vehicle_excesses": {},"driver_excesses": [ ],"compulsory_excess": 0}';
  vehicle_premiums_key: string = '';
  vehicle_premiums_value: number = 0;
  gross_premium: number = 0;
  commission: number = 0;
  total_amount: number = 0;
  peliwica_fee: number = 0;
  broker_admin_fee: number = 0;
  premium_excl_ipt: number = 0;
  total_prem_inc_ipt: number = 0;
  ipt: number = 0;
  UK_HB_INSURANCE_COMPANY_ID = '';
  quote;

  @Input() set quoteDetails(value: any) {
    const isEmpty = Object.keys(value).length === 0;

    if (!isEmpty) {
      this.quote = value;
      const summary = this.quote?.financial_details?.financial_summary?.[0];
      if (!summary) return;

      this.premium = summary.basic_premium;
      this.commission = summary.broker_pay_away_commission;
      this.broker_admin_fee = summary.broker_admin_fee;
      this.ipt = Number(summary.ipt_value) || 0;
      this.premium_excl_ipt = Number(summary.premium_excl_ipt) || 0;
      this.total_prem_inc_ipt = Number(summary.total_premium_inc_ipt) || 0;
      this.gross_premium = Number(summary.breakdown_gross) || 0;

      const totalPolicyCost = Number(this.quote.financial_details?.total_policy_cost);
      this.total_amount = totalPolicyCost > 0 ? totalPolicyCost : this.total_prem_inc_ipt;
    }
  }

  constructor(private quoteService: QuoteService, private sessionSt: LocalStorageService) {
  }

  ngOnInit(): void {
    this.UK_HB_INSURANCE_COMPANY_ID = environment.UK_HB_INSURANCE_COMPANY_ID;
  }

  /*
  * Get Peliwica Fee
  */
  public getPeliwicaPremium() {
    // refactor this code
    this.quoteService
      .getLiveStockBrokerCommission(this.sessionSt.retrieve('userInfo').company_id, environment.BREAKDOWN_ID)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.peliwica_fee = response.result.broker_admin_fee;
          }
        }
      );
  }

}
